import MaskedTextInput from './MaskedTextInput';

export default MaskedTextInput;
